var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('welcome',{ref:"welcomeRef"}),_c('nav',{staticClass:"tab-bar"},_vm._l((_vm.tabs),function(item,index){return _c('div',{key:index,staticClass:"tab-item",class:{ active: _vm.$route.name === item.routeName },on:{"click":function($event){return _vm.navigateTo(index)}}},[_c('span',[_vm._v(_vm._s(item.text))])])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }